<template>
    <div class="home-wrapper wrapper">
		<swiper ref="mySwiper" v-if="data" :options="swiperOptions" :style="[data.bg && {'background-image': data.bg.url ? 'url('+ data.bg.url +')' : ''}, data.bg && {'background-color': data.bg.color ? data.bg.color : ''}, (!data.bg || (data.bg && !data.bg.url && !data.bg.color)) && activityData.color && {'background' : activityData.color}]">
			<swiper-slide>
				<div class="page-index" :style="{'background-image': 'url('+ data.home +')'}"></div>
			</swiper-slide>
			<swiper-slide v-for="(newsList, index) in list" :key="index">
				<div class="page-content">
					<div class="page-content-inner">
						<div class="top" :style="[{'background-image': activityData.head ? 'url('+ activityData.head +')' : ''}, !activityData.head && activityData.color && {'background' : activityData.color}]">
							<div class="left">
								<h4 v-if="activityData.subtitle">{{activityData.subtitle}}</h4>
								<h3 v-if="activityData.subtitle">{{activityData.title}}</h3>
								<span>第{{data.no}}期</span>
							</div>
							<div class="right">
								<div class="right-inner">
									<p>{{ data.time | formatTime('YYYY') }}年</p>
									<p>{{ data.time | formatTime('M') }}月<b>{{data.time | formatTime('D') }}</b>日</p>
									<p>{{ data.time | formatTime('week') }}</p>
									<button @click="viewAll" :class="[selectFlag && 'active']">查看往期<i :style="{'border-top-color' : activityData.color}"></i></button>
								</div>
							</div>
						</div>
						<div class="select" v-show="selectFlag">
							<div class="select-inner">
								<div class="select-list" v-for="(item, key) in dates" :key="key">
									<h4>{{key}}年</h4>
									<div class="select-item" v-for="(val, idx) in item" :key="idx" @click="goDaily(val.sid)">
										<p>第{{val.no}}期</p>
										<span>{{val.time | formatTime('M月D日')}}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="news">
							<div class="news-item" v-for="(item, index) in newsList.info" :key="index" @click="goNews(item)">
								<div class="news-item-inner" v-if="index == 0">
									<div class="img">
										<img :src="slimImageFilter(item.img, 628, 472)" alt="">
									</div>
									<div class="info">
										<h3>{{item.title}}</h3>
									</div>
								</div>
								<div class="news-item-inner" v-else>
									<h4>{{item.title}}</h4>
									<p>{{item.brief || item.source}}</p>
								</div>
							</div>
						</div>
						<div class="footer">
							<img :src="activityData.foot" alt="">
							<div class="btn" @click="drawImg">
								<img src="../img/download.png" alt="">
								<img src="../img/download_icon.png" alt="">
								<span>生成海报</span>
							</div>
						</div>
					</div>	
				</div>
			</swiper-slide>
		</swiper>

        <div class="arrow" v-show="list && curIndex < list.length">
            {{curIndex}}
            <img src="../img/arrow.png" alt="">
        </div>

		<div id="qrcode" class="qrcode" ref="qrcodeContainer"></div>  

		<!-- 海报蒙层 -->
		<div class="poster-mask" :class="[isApp && 'poster-isapp-mask']" v-if="drawPosterFlag">
			<div class="poster-mask-content" :class="[posterClass]" v-if="!isDrawing">
				<div class="poster-img-wrap">
					<div class="poster-img-inner">
						<a href="" @click="posterImgClick">
							<img id="poster_img" :src="shareImg" alt="" />
						</a>	
					</div>
					<div class="poster-close" @click="closePosterMask">
						<img src="https://yunyingcdn.thecover.cn/o_1e054uo2g1ctb14uqkv0mit4blp.png" alt=""/>
					</div>
                    <span class="poster-text">长按图片保存到手机</span>
				</div>
				<div class="poster-share">
					<div class="poster-share-btns">
						<div class="poster-share-btn" @click="sharePosterImg('Weixin')">
							<img src="https://yunyingcdn.thecover.cn/o_1e054uo2g1e9b16bfrgtqodo011.png" alt="" />
							<span>微信</span>
						</div>
						<div class="poster-share-btn" @click="sharePosterImg('Timeline')">
							<img src="https://yunyingcdn.thecover.cn/o_1e054uo2gej9obher82e9f810.png" alt=""/>
							<span>朋友圈</span>
						</div>
					</div>
					<span class="poster-share-close" @click="closePosterMask">取消</span>
				</div>
			</div>
			<div class="poster-mask-loading" v-if="isDrawing">
				图片生成中，请稍后...
			</div>
		</div>

		<!-- toast提示 -->
        <div class="toast" v-if="toastData">
            <p class="toast-inner">
                {{toastData.text}}
            </p>
        </div>
    </div>
</template>

<script>

import '../less/common.less'

import COVER from '@/utils/COVER'
import UploadComponent from '@/components/Upload'
import DialogComponent from '@/components/Dialog'
import COVERAPP from '@/utils/COVERAPP'
import FILTER from '@/utils/filters'

import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import moment from 'moment';
import QRCode from 'qrcodejs2'

import { mapState, mapActions } from 'vuex'

export default {
    name: 'home',
    data() {
		let _this = this;
        return {
			isApp: false,
			id: '',
			sid: '',
			toastData: null,
			selectFlag: false,
			curIndex: 0,
			posterClass: '',
			drawPosterFlag: false,
			shareImg: '',
            isDrawing: false,
			data: null,
			dates: [],
			swiperOptions: {
				direction : 'vertical',
				noSwiping: true,
    			noSwipingSelector: '.select',
				on: {
					slideChangeTransitionStart() {
						_this.selectFlag = false;
					},
					slideChangeTransitionEnd() {
						_this.curIndex = this.activeIndex;
						if(this.activeIndex == 1) {
							_this.swiper.allowSlidePrev = false;
						} else {
							_this.swiper.allowSlidePrev = true;
						}
					},
				}
			},
			list: null
        }
    },
    props: ['activityData', 'baseData'],
	computed: {
		swiper() {
			return this.$refs.mySwiper.$swiper
		}
	},
	components: {
		Swiper,
		SwiperSlide
	},
	watch: {
        toastData(val) {
            if(val) {
                setTimeout(()=> {
                    this.toastData = null
                }, 3000)
            }
        },
        list(val) {
            if(val.length) {
                this.curIndex = sessionStorage.getItem('COVER_Daily_Index') || 0;
                this.$nextTick(() => {
                    this.swiper.slideTo(this.curIndex, 0, false);
                    sessionStorage.setItem('COVER_Daily_Index', 0);
                });
            }
        }
    },
	created() {
		this.id = this.$route.query.id || '';
        this.sid = this.$route.query.sid || '';
		this.getData()
		this.formatDates();
	},
	mounted() {
        this.htmlRem();
		window.addEventListener('resize', this.htmlRem);
		this.isApp = COVERAPP.Attribute.isApp();
		this.share();
		this.showQRCode();
		window.addEventListener('pageshow', (event) => {
			if(event.persisted){
				location.reload();   
			}
		});
		// COVER.track(this.id, 'load', '首页加载');
	},
    methods: {
		//分享
        share() {
            let data = this.baseData.share;
            let shareData = {
                title: data.title,
                desc: data.desc,
                imgUrl: data.imgUrl,
                link: window.location.href
            }
            COVER.share(shareData)
        },
		...mapActions([
			'setPageLoadingAsync'
		]),
		getData() {
			COVER.$get('/daily', {
				aid: this.id,
				sid: this.sid
			}).then(res => {
				if(res.errno == 0 && res.data) {
					this.data = res.data.info;
					this.dates = res.data.stage;
					this.list = res.data.news;
                    this.formatDates();
                    this.pageImgLoad();
				}
			})
		},
		// 页面所需图片加载
		pageImgLoad() {
			Promise.all([this.defPreImage(this.data.home), this.defPreImage(require('../img/select_bg_top.png')), this.defPreImage(require('../img/select_bg_bottom.png')), this.defPreImage(require('../img/select_bg_center.png'))]).then((res) => {
				this.setPageLoadingAsync(false);
			});
		},
		formatDates() {
			let dates = JSON.parse(JSON.stringify(this.dates));
			let newDates = {};
			dates.forEach((val, idx) => {
				let year = moment(val.times).format('YYYY');
				let index = Object.keys(newDates).indexOf(year);
				if(index > -1) {
					newDates[year].push(val);
				} else {
					newDates[year] = [];
					newDates[year].push(val);
				}
			});
			this.dates = JSON.parse(JSON.stringify(newDates));
		},
		showQRCode(){  
			var qrcode = new QRCode(this.$refs.qrcodeContainer, {  
				text: window.location.href,  
				width: 200,  
				height: 200,  
				colorDark: '#000000',  
				colorLight: '#ffffff',  
				correctLevel: QRCode.CorrectLevel.H  
			});  
		}, 
		viewAll(e) {
			e.stopPropagation();
			this.selectFlag = !this.selectFlag;
        },
        goDaily(sid) {
			sessionStorage.setItem('COVER_Daily_Index', 0);
            this.$router.push(`/?id=${this.id}&sid=${sid}`);
            window.location.reload();
        },
        goNews(item) {
            sessionStorage.setItem('COVER_Daily_Index', this.curIndex);
            window.location.href = FILTER.linkFilter(item);
		},
		posterImgClick(e) {
			e.preventDefault();
		},
		drawImg() {
			this.drawPosterFlag = true
            this.isDrawing = true
			let c = document.createElement('canvas');
			let ctx = c.getContext('2d');
			let dom = document.querySelectorAll('.page-content-inner')[this.curIndex - 1];
			let newsImg = dom.querySelector('.news-item img').src;
			var QRCodeImg = document.querySelector('#qrcode img').src || document.querySelector('#qrcode canvas').toDataURL("image/jpeg");
			var QRCodeBg = require('../img/code_bg.png');
            Promise.all([this.defPreImage(this.activityData.foot), this.defPreImage(newsImg), this.defPreImage(QRCodeImg), this.defPreImage(QRCodeBg), this.activityData.head && this.defPreImage(this.activityData.head)]).then((imgs) => {
				c.width = 750;
				c.height = 1333;
				ctx.fillStyle = '#fff';
                ctx.fillRect(0, 0, c.width, c.height); 
                if(imgs.length >= 5) {
                    ctx.drawImage(imgs[4], 0, 0, imgs[4].width, imgs[4].height, 24, 21, 702, 218);
                } else {
                    ctx.fillStyle = this.activityData.color;
				    ctx.fillRect(24, 21, 702, 218); 
                }	
				this.activityData.subtitle && this.writeText(ctx, this.activityData.subtitle, {
                    font: 'bold 22px',
                    align: 'center',
                    baseline: 'top',
                    color: '#fff'
				}, 578, 289, 40, 0, 15);
				this.activityData.subtitle && this.writeText(ctx, this.activityData.title, {
                    font: 'bold 111px',
                    align: 'center',
                    baseline: 'top',
                    color: '#fff'
				}, 578, 289, 74);
				let numWidth = this.writeText(ctx, `第${this.data.no}期`, {
                    font: 'bold 20px',
                    align: 'center',
                    baseline: 'top',
                    color: '#fff'
				}, 578, 289, 205);
				this.linearGradient(ctx, (578 - numWidth) / 2 + numWidth + 20, 218, (578 - numWidth) / 2 + numWidth + 140, 218, 'rgba(255,255,255,1)', 'rgba(255,255,255,0)', 1);
				this.linearGradient(ctx, (578 - numWidth) / 2 - 140 , 218, (578 - numWidth) / 2 - 20, 218, 'rgba(255,255,255,0)', 'rgba(255,255,255,1)', 1);
				this.writeText(ctx, moment(this.data.time).format('YYYY年'), {
                    font: '18px',
                    align: 'left',
                    baseline: 'top',
                    color: '#fff'
				}, 120, 618, 72);
				let monWidth = this.writeText(ctx, moment(this.data.time).format('M月'), {
                    font: '18px',
                    align: 'left',
                    baseline: 'top',
                    color: '#fff'
				}, 120, 618, 121);
				let dateWidth = this.writeText(ctx, moment(this.data.time).format('D'), {
                    font: 'bold 40px',
                    align: 'left',
                    baseline: 'top',
                    color: '#fff'
				}, 120, 618 + monWidth, 107);
				this.writeText(ctx, '日', {
                    font: '18px',
                    align: 'left',
                    baseline: 'top',
                    color: '#fff'
				}, 120, 618 + monWidth + dateWidth, 121);
				this.writeText(ctx, FILTER.formatTime(this.data.time, 'week'), {
                    font: '18px',
                    align: 'left',
                    baseline: 'top',
                    color: '#fff'
				}, 120, 618, 168);
				ctx.drawImage(imgs[1], 0, 0, imgs[1].width, imgs[1].height, 24, 244, 702, 528);
				ctx.fillStyle = '#F2F2F1';
				ctx.fillRect(24, 772, 702, 58); 
				this.writeText(ctx, dom.querySelectorAll('.news-item')[0].querySelector('h3').innerText, {
                    font: 'bold 24px',
                    align: 'left',
                    baseline: 'top',
                    color: '#606060'
				}, 680, 43, 790);
				this.writeText(ctx, dom.querySelectorAll('.news-item')[1].querySelector('h4').innerText, {
                    font: 'bold 46px',
                    align: 'center',
                    baseline: 'top',
                    color: '#000'
				}, 702, 375, 883);
				this.writeText(ctx, dom.querySelectorAll('.news-item')[1].querySelector('p').innerText, {
                    font: '28px',
                    align: 'center',
                    baseline: 'top',
                    color: '#000'
				}, 702, 375, 943);
				this.linearGradient(ctx, 24, 1020, 706, 1020, '#C1C1C1', '#C1C1C1', 1);
				this.writeText(ctx, dom.querySelectorAll('.news-item')[2].querySelector('h4').innerText, {
                    font: 'bold 46px',
                    align: 'center',
                    baseline: 'top',
                    color: '#000'
				}, 702, 375, 1070);
				this.writeText(ctx, dom.querySelectorAll('.news-item')[2].querySelector('p').innerText, {
                    font: '28px',
                    align: 'center',
                    baseline: 'top',
                    color: '#000'
				}, 702, 375, 1130);
				ctx.drawImage(imgs[0], 0, 0, imgs[0].width, imgs[0].height, 29, 1242, 696, 63);
				ctx.drawImage(imgs[3], 0, 0, imgs[3].width, imgs[3].height, 509, 1209, 203, 117);
				ctx.drawImage(imgs[2], 0, 0, imgs[2].width, imgs[2].height, 519, 1218, 100, 100);
				this.writeText(ctx, '扫码阅读', {
                    font: 'bold 16px',
                    align: 'left',
                    baseline: 'top',
                    color: '#000'
				}, 200, 631, 1263, 0, 2);
                this.shareImg = c.toDataURL("image/jpeg")
                this.isDrawing = false
                this.$nextTick(()=> {
                    setTimeout(() => {
                        this.posterClass = 'show'
                    }, 300);                  
                })             
            })
		},
		//加载图片
        defPreImage(url) {
            return new Promise((resolve, reject) =>{
                let img = new Image()
                img.crossOrigin = "Anonymous";  
                img.src = url;           
                img.onload = function () { 
                    resolve(img);  
                } 
            })
        },
        //写字
        writeText(ctx, text, textStyle, width, left, top, lineHeight, letterSpacing) {
            ctx.font = `${textStyle.font} "Helvetica", "PingFang SC", "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif`;
            ctx.textAlign = textStyle.align
            ctx.textBaseline = textStyle.baseline
			ctx.fillStyle = textStyle.color
			let line = '';
			if(letterSpacing) {
				var arrText = text.split('');
				var align = ctx.textAlign || 'left';
				
				// 这里仅考虑水平排列
				var originWidth = ctx.measureText(text).width;
				// 应用letterSpacing占据宽度
				var actualWidth = originWidth + letterSpacing * (arrText.length - 1);
				// 根据水平对齐方式确定第一个字符的坐标
				if (align == 'center') {
					left = left - actualWidth / 2;
				} else if (align == 'right') {
					left = left - actualWidth;
				}
				
				// 临时修改为文本左对齐
				ctx.textAlign = 'left';
				// 开始逐字绘制
				arrText.forEach(function (letter) {
					var letterWidth = ctx.measureText(letter).width;
					ctx.fillText(letter, left, top);
					// 确定下一个字符的横坐标
					left = left + letterWidth + letterSpacing;
				});
				// 对齐方式还原
				ctx.textAlign = textStyle.align;
			} else if(lineHeight) {
                for (let n = 0; n < text.length; n++) {
					let textLine = line + text[n];
                    let metrics = ctx.measureText(textLine);
                    let textWidth = metrics.width;
                    if (textWidth > width && n > 0) {                       
                        if('，！。？；《'.indexOf(text[n]) > -1) {
                            ctx.fillText(line.slice(0, n - 1), left, top);
                            line = `${text[n-1]}${text[n]}`;
                        } else {
                            ctx.fillText(line, left, top);
                            line = text[n];
                        }                 
                        top += lineHeight;
                    } else {
                        line = textLine;
                    }
                }
            } else {
                for (let n = 0; n < text.length; n++) {
					let textLine = line + text[n];
                    let metrics = ctx.measureText(textLine);
                    let textWidth = metrics.width;
                    if (textWidth > width && n > 0) { 
						line = `${line.slice(0, n - 1)}...`;                      
						break;
                    } else {
                        line = textLine;
                    }
                }
            }  
            ctx.fillText(line, left, top)
            return ctx.measureText(line).width
        },
        //加载图片
        defPreImage(url) {
            return new Promise((resolve, reject) =>{
                let img = new Image()
                img.crossOrigin = "Anonymous";  
                img.src = url;           
                img.onload = function () { 
                    resolve(img);  
                } 
            })
		},
		linearGradient(ctx, x1, y1, x2, y2, color1, color2, h) {
			ctx.beginPath();
			ctx.moveTo(x1, y1);
            ctx.lineTo(x2, y2);
            var gnt1 = ctx.createLinearGradient(x1, y1, x2, y2);//线性渐变的起止坐标
            gnt1.addColorStop(0, color1);//创建渐变的开始颜色，0表示偏移量，个人理解为直线上的相对位置，最大为1，一个渐变中可以写任意个渐变颜色
            gnt1.addColorStop(1, color2);
            ctx.lineWidth = h;
			ctx.strokeStyle = gnt1;
			ctx.closePath();
			ctx.stroke();
		},
        closePosterMask() {
            this.posterClass = 'hide'
            setTimeout(() => {
                this.posterClass = ''
                this.drawPosterFlag = false
            }, 300);
        },
        sharePosterImg(origin) {
			let shareData = this.baseData.share;
            let dataUrl = this.shareImg.split(';base64,')[1];
            let imgShareData = {
                title: shareData.title,  // 分享标题
                desc: shareData.desc,  // 分享描述
                link: window.location.href,
                imgUrl: shareData.imgUrl,
                type: 'image',
                imgType: 'jpeg',
                origin: origin,
                dataUrl: dataUrl
            }
            COVERAPP.Method.Share(imgShareData);
        },
		slimImageFilter(img, imgW, imgH) {
			return FILTER.slimImageFilter(img, imgW, imgH)
        },
        htmlRem() {
            if(document.documentElement.clientWidth / document.documentElement.clientHeight<= 0.63){
                document.documentElement.style.fontSize = document.documentElement.clientWidth / 10 + 'px';
            }else{
                var thisWidth = document.documentElement.clientHeight * 0.63;
                document.documentElement.style.fontSize = thisWidth / 10 + 'px';
            } 
            let html = document.getElementsByTagName('html')[0];
            let winFontS = parseFloat(window.getComputedStyle(html).fontSize);
            let htmlFontS = parseFloat(html.style.fontSize);
            let setFontS = htmlFontS;
            if (winFontS != htmlFontS) {
                let whileCount = 0;
                while (true) {
                    winFontS = parseFloat(window.getComputedStyle(html).fontSize);
                    let delta = winFontS - htmlFontS;
                    if (Math.abs(delta) >= 0.1) {
                        if (delta > 0) setFontS = setFontS - 0.1;
                        else setFontS = setFontS + 0.1;
                        html.setAttribute('style', 'font-size:' + setFontS + 'px!important');
                    } else {
                        break;
                    }
                    if (whileCount++ > 200) {
                        break;
                    }
                }
            }
        }
	},
	filters: {
		formatTime(time, str) {
			return FILTER.formatTime(time, str);
        }
    }
}
</script>